export enum Eye {
  RIGHT = 'right',
  LEFT = 'left',
}

export enum ShootingEyeType {
  OS = 'OS',
  OD = 'OD',
}

export enum EyePropertyCode {
  LEFT = 'Left',
  RIGHT = 'Right',
}

export const EyeToShootingType: Record<Eye, ShootingEyeType> = {
  [Eye.RIGHT]: ShootingEyeType.OD,
  [Eye.LEFT]: ShootingEyeType.OS,
};
